export default __webpack_public_path__ + "static/media/paisa-hoga.acb48e65.gif";